import { Link } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"
import { PublicLayout } from "../../layouts"


export const TermsAndConditionsPage = () => {
    return (
        <PublicLayout>
            TermsAndConditionsPage <br />
            <Link component={RouterLink} to={`/`} color="primary.main">
                VOLVER
            </Link>


        </PublicLayout>
    )
}
